<div class="modal-header">
  <h4 class="modal-title">
    <span *ngIf="isNew" i18n="create schedule form title|The title of the schedule form modal when a new schedule is being created@@newScheduleFormTitle">New Schedule</span>
    <span *ngIf="!isNew" i18n="edit schedule form title|The title of the schedule form modal when a previous schedule is being edited is being created@@editScheduleFormTitle">Edit Schedule</span>
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(null)">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="scheduleForm">
    <input type="hidden" formControlName="IdSchedule" />
    <div class="form-group recurrence">
      <label i18n="recurrence selector label at schedule|The label before the selector to choose the schedule recurence type@minuteInputLabelHourlySchedule">Repeat every</label>
      <select
        formControlName="Recurrence"
        class="form-control recurrence"
        [value]="Recurrence.value"
        (change)="onScheduleTypeChange($event)"
        ngbAutofocus
      >
        <option i18n="day selection schedule recurrence option|The selection for schedule recurrence for a schedule to repeat daily@@daySelectionScheduleRecurrenceOption" value="daily">day</option>
        <option i18n="week selection schedule recurrence option|The selection for schedule recurrence for a schedule to repeat weekly@@monthSelectionScheduleRecurrenceOption" value="weekly">week</option>
        <option i18n="month selection schedule recurrence option|The selection for schedule recurrence for a schedule to repeat monthly@@yearSelectionScheduleRecurrenceOption" value="monthly">month</option>
      </select>
    </div>
    <div class="recurrence-group hourly" *ngIf="Recurrence.value === 'hourly'">
      <div class="form-group single-hour-input-wrapper">
        <label i18n="minute selector label for hourly schedule|The label in a hourly recurrent schedule for the input that allows the user to specify the minute that the recurrent schedule will run@minuteInputLabelHourlySchedule">At minute</label>
        <input class='form-control' />
      </div>
    </div>
    <div class="recurrence-group daily" *ngIf="Recurrence.value === 'daily'">
      <div class="form-group">
        <label i18n="hours selector label for daily schedule|The label in a daily recurrent schedule for the input that allows the user to specify which hours to run the recurrent schedule@dayInputLabelDailySchedule">Time</label>
        <div class="day-hour-list">
          <app-day-hour-input
            [control]="Times"
          ></app-day-hour-input>
        </div>
      </div>
    </div>
    <div class="recurrence-group weekly" *ngIf="Recurrence.value === 'weekly'">
      <div class="form-group">
        <label i18n="weekday selector label for weekly schedule|The label in a weekly recurrent schedule for the input that allows the user to specify which weekdays to run the recurrent schedule@weekdayInputLabelWeeklySchedule">On weekdays</label>
        <div class="day-list">
          <app-weekday-select-input [control]="Weekdays"></app-weekday-select-input>
        </div>
      </div>
      <div class="form-group single-hour-input-wrapper">
        <label i18n="time selector label for weekly schedule|The label for the weekly recurrent schedule for the input that allows the user to specify the hour and time to run the recurrent schedule@timeSelectorInputLabelWeeklySchedule">At hour</label>
        <app-hour-minute-input [control]="Time"></app-hour-minute-input>
      </div>
    </div>
    <div class="recurrence-group monthly" *ngIf="Recurrence.value === 'monthly'">
      <div class="form-group">
        <label i18n="days selector label for monthly schedule|The label for the monthly recurrent schedule for the input that allows the user to specify the days to run the recurrent schedule@timeSelectorInputLabelWeeklySchedule">On days</label>
        <div class="month-day-list">
          <app-month-day-input
            [control]="Days"
          ></app-month-day-input>
        </div>
      </div>
      <div class="form-group single-hour-input-wrapper">
        <label i18n="time selector label for monthly schedule|The label for the monthly recurrent schedule for the input that allows the user to specify the hour and time to run the recurrent schedule@@timeSelectorInputLabelMonthlySchedule">At hour</label>
        <app-hour-minute-input [control]="Time"></app-hour-minute-input>
      </div>
    </div>
    <div class="form-group">
      <div class="checkbox" (click)="onStatusSwitch()">
        <i *ngIf="Status.value" class="fa fa-check-square fa-lg"></i>
        <i *ngIf="!Status.value" class="fa fa-square fa-lg"></i>
        <label i18n="checkbox label of schedule activeness@@timeSelectorInputLabelScheduleActive">Active</label>
      </div>
    </div>
    <ul
      class="alert alert-danger"
      *ngIf="forceFormShowError && scheduleForm.invalid"
      >
      <li
        *ngIf="this.Weekdays.invalid"
        i18n="schedule invalid weekday selection|Error message shown when the weekday selection is invalid or empty at the schedule form@@invalidScheduleWeekdaySelection"
      >You must select at least one week day</li>
      <li
        *ngIf="this.Time.invalid"
        i18n="schedule invalid time selection|Error message shown when the time input is invalid or empty at the schedule form@@invalidScheduleTimeSelection"
      >You must input a correct time</li>
      <li
        *ngIf="!this.Weekdays.invalid && !this.Time.invalid"
        i18n="generic form validation error message|A generic message to show to the user when some generic and unspecified input is invalid or empty@@genericInvalidFormMessage"
      >Please fill the form inputs correctly</li>
    </ul>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" (click)="onCancelClick()">
    <span i18n="cancel changes schedule action|The label of the button used to close the schedule form, cancelling changes if they were made, at the schedule form modal@@cancelChangesScheduleAction">Close</span>
  </button>
  <button type="button" class="btn btn-primary" (click)="onSubmitClick()">
    <span i18n="create schedule final main action|The label of the button used to finish the creation of a schedule at the schedule form modal@@newScheduleFinalActionLabel" *ngIf="isNew">Create</span>
    <span i18n="update schedule final main action|The label of the button used to finish the edition of a previously created schedule at the schedule form modal@@updateScheduleFinalActionLabel" *ngIf="!isNew">Save</span>
  </button>
</div>
